<!--
 * @Description: 酒店主页
 * @Author: wjh
 * @Date: 2021-3
 * @LastEditors: wjh
 -->

<template>
	<div class="hotel">
		<main>
			<!-- 被缓存的组件渲染 -->
			<keep-alive>
				<router-view v-if="$route.meta.keepAlive"></router-view>
			</keep-alive>
			<!--未被缓存的组件 -->
			<router-view v-if="!$route.meta.keepAlive"></router-view>
		</main>
		<Footer v-if="footerShow"  :footInfo="this.footInfo"></Footer>
		<Nav v-if="fNavShow"></Nav>
		<hotelList v-if="signShow" @homeFun="getHome" @logoFun="getLogo" @meetinginfo="getMeetinginfo"></hotelList>
	</div>
</template>
<script>
	import Footer from '@components/Footer';
	import Nav from './components/navigation.vue'
	import hotelList from './HotelList.vue'
	export default {
		neme: 'hotel',
		components: {
			Footer,
			Nav,
			hotelList
		},
		data() {
			return {
				show: false,
				footerShow: true,
				isshowlogoNew: '',
				fNavShow: true,
				signShow: false,
				homeUrl: '',
				isshowlogo: '',
				footInfo: {
					LogoTxt: '',
					LogoLink: '',
					LogoImg: '',
				},
			}
		},
		created() {},
		methods: {
			async getMeetinginfo(data){
				this.footInfo.LogoTxt = data.LogoTxt
				this.footInfo.LogoLink = data.LogoLink
				this.footInfo.LogoImg = data.LogoImg
			},
			async getHome(data) {
				if (this.signShow) {
					this.homeUrl = data
					console.log(this.homeUrl)
					this.signShow = false
					this.inits()
				}
			},
			async getLogo(data) {
				if (this.signShow) {
					this.isshowlogo = data
					console.log(this.isshowlogo)
					this.signShow = false
					this.inits()
				}
			},
			async inits() {
				//let isshowlogo = sessionStorage.getItem("isshowlogo")
				//let HomeUrl = sessionStorage.getItem("HomeUrl")
				if (this.isshowlogo === 1) {
					this.footerShow = false
				}
				// if ( this.homeUrl == null || this.homeUrl == '') {
				//   this.fNavShow = false
				// } else{
				//   this.fNavShow = true
				// }

			}
		},
		watch: {
			'$route'(to, from) {
				//this.init()
			}
		}
	};
</script>
<style lang="scss">
	.hotel {
		padding-bottom: 100px;
	}

	// vant 加载样式
	.loading {
		width: 100%;
		margin: 20% auto;

		>div {
			width: 200px;
			margin: 0 auto;
			padding: 40px 0;
			border-radius: 10px;
		}
	}

	// 消息通知
	.van-notify {
		font-size: 28px;
		line-height: 2rem;
	}

	// 弹框
	.van-dialog {
		width: 50%;

		.van-dialog__message {
			font-size: 28px;
			color: #1e293b;
			line-height: 40px;
		}
	}
</style>
<style type="text/css">
	#app {
		font-size: 26px;
	}
</style>
